/**
 * 입력 검증 관련 상수
 */

/**
 * 전화번호 검증 정규식
 * - 숫자, 하이픈, 괄호, 공백, + 기호 허용
 * - 최소 8자, 최대 20자
 */
export const PHONE_REGEX = /^[\d\-+() ]{8,20}$/;

/**
 * 주문 아이템 검증 제한
 */
export const ORDER_ITEM_LIMITS = {
  MAX_QUANTITY: 99,
  MAX_INSTRUCTIONS_LENGTH: 500,
} as const;

/**
 * 비밀번호 생성 설정
 */
export const PASSWORD_CONFIG = {
  LENGTH: 8,
  MIN_LETTER_COUNT: 1,
  MIN_DIGIT_COUNT: 1,
} as const;

/**
 * 지원되는 주문 타입 매핑
 * 프론트엔드 주문 타입을 백엔드 API 주문 타입으로 변환
 */
export const SUPPORTED_ORDER_TYPES = {
  pickup: 'pickup',
  delivery: 'pickup', // 임시: delivery는 아직 미지원, pickup으로 폴백
  table: 'table',
} as const;
